import { Templates } from "choices.js/public/types/src/scripts/interfaces/templates";
import { TemplateType, UGElement } from "../models/module";

export function setPostTypeForTemplate(element: UGElement): string {
  if (element.postType == "tidspunkt") {
    return element.activityPostType;
  } else {
    return element.postType;
  }
}

export function setTemplateType(
  element: UGElement,
  baseType: string
): TemplateType {
  if (element.postType === "tidspunkt") {
    return `${baseType}Timestamp` as TemplateType;
  } else {
    return baseType as TemplateType;
  }
}

export function getTemplate(
  element: UGElement,
  templates: Record<string, any>,
  baseType: string
): any {
  const templateType =
    element.postType === "tidspunkt" ? `${baseType}Timestamp` : baseType;
  return templates[templateType];
}
